import { DashboardWidgetWidth } from '@/components/dashboard/model';
import {
  DashboardDateScopeMode,
  DashboardMetric,
  DashboardWidgetAction,
} from '../../../dashboard/model';
import { networkDashboardDocumentSchema, NetworkDashboardWidgetType } from './widgetModel';
import { NetworkDashboardSection } from './widgetModel';

const inherit = { mode: DashboardDateScopeMode.Inherit } as const;

export const defaultNetworkDashboardDocument = networkDashboardDocumentSchema.parse({
  version: 1,
  widgets: [
    metric('network-ad-requests', DashboardMetric.AdRequests),
    metric('network-ad-impressions', DashboardMetric.AdImpressions),
    metric('network-revenue', DashboardMetric.Revenue),
    metric('network-profit', DashboardMetric.Profit),
    {
      id: 'network-performance',
      type: NetworkDashboardWidgetType.PerformanceChart,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit,
      metrics: [
        DashboardMetric.AdRequests,
        DashboardMetric.AdImpressions,
        DashboardMetric.FillRate,
        DashboardMetric.Rpm,
        DashboardMetric.Revenue,
        DashboardMetric.Profit,
      ],
      actions: [DashboardWidgetAction.PerformanceAnalyzer],
    },
    {
      id: 'network-performance-tables',
      type: NetworkDashboardWidgetType.PerformanceTables,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit,
      pageSize: 10,
    },
    {
      id: 'network-demand-sources-heading',
      type: NetworkDashboardWidgetType.SectionHeading,
      width: DashboardWidgetWidth.Full,
      dateScope: inherit,
      section: NetworkDashboardSection.DemandSources,
    },
    distribution('network-revenue-distribution', NetworkDashboardWidgetType.RevenueDistribution),
    distribution('network-won-bids-distribution', NetworkDashboardWidgetType.WonBidsDistribution),
    {
      id: 'network-demand-performance',
      type: NetworkDashboardWidgetType.DemandPerformance,
      width: DashboardWidgetWidth.Third,
      dateScope: inherit,
      pageSize: 5,
    },
  ],
});

function metric(id: string, metric: DashboardMetric) {
  return {
    id,
    type: NetworkDashboardWidgetType.Metric,
    width: DashboardWidgetWidth.Quarter,
    dateScope: inherit,
    metric,
  };
}

function distribution(id: string, type: NetworkDashboardWidgetType) {
  return { id, type, width: DashboardWidgetWidth.Third, dateScope: inherit };
}
